(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/match-list.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/match-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.MatchList = Backbone.Collection.extend({
    model: svs.maltipset.models.Match,
    initialize: function() {
      this.listenTo(this, 'reset', this.onReset);
    },
    matchChangeEnabled: true,
    updateMarkedMatchesCount: function(board) {
      var self = this;
      this.each(function(match) {
        match.set('matchesMarked', 0);
      });
      board.each(function(row) {
        var selectedMatchIndexes = row.get('selectedMatchIndexes');
        for (var i = 0; i < selectedMatchIndexes.length; i++) {
          if (selectedMatchIndexes[i] === 1) {
            self.at(i).markChanged(true);
          }
        }
      });
    },
    matchClicked: function(clickedMatch, silent) {
      this.matchChangeEnabled = false;
      this.each(function(match) {
        match.set(
          'isSelected',
          match.get('eventNumber') === clickedMatch.get('eventNumber'),
          { silent: silent || false }
        );
      });
      var self = this;
      this.matchChangeEnabledTimer = setTimeout(function() {
        self.matchChangeEnabled = true;
      }, 500);
      this.trigger('currentMatchSet');
    },
    onReset: function() {
      var hasTTT = _.some(this.models, function(match) {
        return (
          match.get('tioTidningar') &&
          ((match.get('tioTidningar').x && match.get('tioTidningar').x > 0) ||
            (match.get('tioTidningar').rank &&
              match.get('tioTidningar').rank > 0))
        );
      });

      if (hasTTT) {
        var rankings = _.sortBy(this.models, function(match) {
          var rank = match.get('tioTidningar').x
            ? match.get('tioTidningar').x
            : match.get('tioTidningar').rank;
          if (!rank) {
            rank = 0;
          }
          return -rank;
        }).slice(0, 8);

        _.each(rankings, function(match) {
          if (match.get('tioTidningar')) {
            match.get('tioTidningar').isTopRank = true;
          }
        });
      }
    },
    getCurrentMatch: function() {
      return _.find(this.models, function(match) {
        return match.get('isSelected');
      });
    },

    hasMatchData: function() {
      return _.every(this.models, function(item) {
        return item.get('match') != undefined;
      });
    },

    getAllMatches: function() {
      return this.models;
    }
  });
})(Backbone, _, svs);


 })(window);